import notifications from 'notifications';

import {MAX_GRID_IMAGES} from './imageTypeUtils';

/**
 * Limit candidate images to the remaining capacity in a grid and warn when
 * some or all of them cannot be added.
 *
 * `existingImageCount` is the number of images that will remain in the grid
 * before the candidates are added. Callers replacing images should exclude
 * the images being replaced from that count.
 */
export function capImagesForGrid<T>(images: Array<T>, existingImageCount: number): Array<T> {
  const availableSlots = MAX_GRID_IMAGES - existingImageCount;
  if (availableSlots <= 0) {
    notifications.warn(`Maximum of ${MAX_GRID_IMAGES} images allowed in a grid.`);
    return [];
  }

  if (images.length > availableSlots) {
    notifications.warn(
      `You can only add ${availableSlots} more image${availableSlots !== 1 ? 's' : ''}. Maximum of ${MAX_GRID_IMAGES} images allowed.`
    );
    return images.slice(0, availableSlots);
  }

  return images;
}
